var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled, { css } from '../../styled';
const directionMap = {
    vertical: 'row',
    horizontal: 'column',
};
const Wrapper = styled.div `
  display: flex;
  width: ${({ width }) => width || '100%'};
  height: ${({ height }) => height || '2.75rem'};
  box-sizing: border-box;
  flex-direction: ${({ direction }) => directionMap[direction] || 'column'};
  padding: ${({ theme, hPadding, wPadding }) => `${theme.dynamicEditor.hPadding[hPadding]} ${theme.dynamicEditor.wPadding[wPadding]}`};
  text-align: center;
  justify-content: center;
  background-color: ${({ disabled, theme, themeKey }) => disabled
    ? theme.colors[theme.dynamicEditor.types[themeKey].disabledBackgroundColor]
    : theme.colors[theme.dynamicEditor.types[themeKey].backgroundColor]};
  border-radius: ${({ borderRadius }) => borderRadius || '0'};

  ${({ disabled, theme, themeKey }) => disabled
    ? css `
          cursor: not-allowed;
        `
    : css `
          border-style: dashed;
          border-width: 1px;
          border-color: ${theme.colors[theme.dynamicEditor.types[themeKey].borderColor]};
          :hover {
            cursor: pointer;
            background-color: ${theme.colors[theme.dynamicEditor.types[themeKey].hoverBackgroundColor]};
            border-color: ${theme.colors[theme.dynamicEditor.types[themeKey].hoverBorderColor]};
          }

          :active {
            cursor: pointer;
            background-color: ${theme.colors[theme.dynamicEditor.types[themeKey].activeBackgroundColor]};
            border-color: ${theme.colors[theme.dynamicEditor.types[themeKey].activeBorderColor]};
          }
        `};
`;
const IconWrapper = styled.div `
  margin-bottom: ${({ direction }) => direction === 'vertical' ? '0' : '0.25rem'};
  path {
    fill: ${({ theme, themeKey, disabled }) => disabled
    ? theme.colors[theme.dynamicEditor.types[themeKey].disabledTextColor]
    : theme.colors[theme.dynamicEditor.types[themeKey].activeTextColor]};
  }

  ${({ disabled, theme, themeKey }) => !disabled &&
    css `
      ${Wrapper}:hover & {
        path {
          fill: ${theme.colors[theme.dynamicEditor.types[themeKey].hoverTextColor]};
        }
      }

      ${Wrapper}:active & {
        path {
          fill: ${theme.colors[theme.dynamicEditor.types[themeKey].activeTextColor]};
        }
      }
    `};
`;
const Content = styled.div `
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.43;
  padding-left: ${({ direction }) => direction === 'vertical' ? '0.25rem' : '0'};
  color: ${({ theme, themeKey, disabled }) => disabled
    ? theme.colors[theme.dynamicEditor.types[themeKey].disabledTextColor]
    : theme.colors[theme.dynamicEditor.types[themeKey].activeTextColor]};

  ${({ disabled, theme, themeKey }) => !disabled &&
    css `
      ${Wrapper}:hover & {
        color: ${theme.colors[theme.dynamicEditor.types[themeKey].hoverTextColor]};
      }

      ${Wrapper}:active & {
        path {
          fill: ${theme.colors[theme.dynamicEditor.types[themeKey].activeTextColor]};
        }
      }
    `};
`;
const DynamicEditorGenerator = (themeKey) => (_a) => {
    var { content, icon, borderRadius, direction = 'horizontal', hPadding = 'MEDIUM', wPadding = 'MEDIUM', disabled = false } = _a, restProps = __rest(_a, ["content", "icon", "borderRadius", "direction", "hPadding", "wPadding", "disabled"]);
    return (React.createElement(Wrapper, Object.assign({}, restProps, { borderRadius: borderRadius, themeKey: themeKey, direction: direction, hPadding: hPadding, wPadding: wPadding, disabled: disabled }),
        icon && (React.createElement(IconWrapper, { disabled: disabled, themeKey: themeKey, direction: direction }, icon)),
        content && (React.createElement(Content, { disabled: disabled, themeKey: themeKey, direction: direction }, content))));
};
export const Basic = DynamicEditorGenerator('basic');
export const Primary = DynamicEditorGenerator('primary');
//# sourceMappingURL=index.js.map